export default __webpack_public_path__ + "static/springandsummer (8)-4a851135ece237006bcb31a8769d3949.jpeg";